module.exports = __webpack_public_path__ + "img/tab-image-sport-qrcode.7ee179f2.png";